import { useQuery } from "@tanstack/react-query";
import { getLeatShops } from "../../api/bLeatApi";

export const useGetLeatShops = (organisationId) => {
  return useQuery({
    queryKey: ["leat-shops", organisationId],
    queryFn: () => getLeatShops(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000,
  });
};
